import React from 'react';

import { useQuery } from '@apollo/client/react';

import { GetOrganizationDocument } from '../graphql/queries/__generated__/GetOrganization';
import { WEB_API_URL } from '../helpers/globals';

type IProps = {
  children?: React.ReactNode;
  className?: string;
};

const PartnerSpecificHomeLink = (props: IProps) => {
  const { loading, error, data } = useQuery(GetOrganizationDocument);

  const homeLinkUrl =
    loading || error || !data || !data.organization || !data.organization.slug
      ? WEB_API_URL
      : `${WEB_API_URL}/${data.organization.slug}`;

  return (
    <a className={props.className} href={homeLinkUrl} target="_blank" rel="noopener noreferrer">
      {props.children}
    </a>
  );
};

export default PartnerSpecificHomeLink;
